import React from 'react';

// Card for `kind: "gtfs.train_time"`. Emitted by gtfs_endpoints.train_time
// after the user picks a Metro-North station. Renders the station name
// header and a row per upcoming arrival (time + status badge). Empty
// state shows a "No upcoming trains" line so the card is still useful
// when the realtime feed has nothing for this stop.
//
// Expected structured shape:
//   { kind: "gtfs.train_time",
//     stop_id: "109", station_name: "Westport",
//     arrivals: [
//       { trip_id, route_id, arrival_time: "10:42 AM",
//         delay_seconds: -120, status: "On Time" }, …
//     ] }
export default function GtfsTrainTimeCard({ structured }) {
  const arrivals = structured.arrivals || [];

  const badgeStyle = (status) => ({
    fontSize: '0.75rem', fontWeight: 600,
    padding: '2px 8px', borderRadius: '10px', marginLeft: '8px',
    background: status === 'On Time' ? '#e6f4ea' : '#fce8e6',
    color: status === 'On Time' ? '#137333' : '#a50e0e',
  });

  const formatDelay = (sec) => {
    if (!sec) return '';
    const minutes = Math.round(sec / 60);
    if (minutes === 0) return '';
    const sign = minutes > 0 ? '+' : '';
    return ` (${sign}${minutes} min)`;
  };

  return (
    <div style={{
      marginBottom: '10px', padding: '12px', background: '#f8f9fa',
      borderRadius: '8px', border: '1px solid #e9ecef',
    }}>
      <div style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: '8px' }}>
        {structured.station_name} — Next trains
      </div>
      {arrivals.length === 0 ? (
        <div style={{ fontSize: '0.9rem', color: '#666', fontStyle: 'italic' }}>
          No upcoming trains in the realtime feed.
        </div>
      ) : (
        <ul style={{
          listStyle: 'none', margin: 0, padding: 0,
          fontSize: '0.95rem', color: '#222',
        }}>
          {arrivals.map((a, i) => (
            <li key={i} style={{
              display: 'flex', alignItems: 'center',
              padding: '6px 0',
              borderTop: i === 0 ? 'none' : '1px solid #e9ecef',
            }}>
              <span style={{ fontWeight: 600, minWidth: '90px' }}>
                {a.arrival_time}
              </span>
              <span style={{ flex: 1, color: '#555', fontSize: '0.85rem' }}>
                {a.route_id ? `Route ${a.route_id}` : `Trip ${a.trip_id || '—'}`}
                {formatDelay(a.delay_seconds)}
              </span>
              {a.status && <span style={badgeStyle(a.status)}>{a.status}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
